import { breakpoints } from '../config/breakpoints';

export default function header() {
  const headerBlock = document.querySelector('.header');
  const cHamburger = document.querySelector('#c-hamburger');
  const isHome = headerBlock.dataset.iswhite;
  const headerHideClass = 'header--hide';
  const activeReserveListClass = 'header__reserve-list--active';
  const reserveButtons = document.querySelector('.header__reserve');
  const popoverElement = document.querySelector('.header__reserve-list');
  let prevScrollPos = window.scrollY;

  function isTouchDevice() {
    return (('ontouchstart' in window)
      || (navigator.maxTouchPoints > 0)
      || (navigator.msMaxTouchPoints > 0));
  }

  function hasScrolled() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (!cHamburger.classList.contains('c-hamburger--open')) {
      if (window.scrollY > 0) {
        if (!isHome) {
          headerBlock.classList.add('header--white', 'header--dark');
          headerBlock.classList.remove('header--page');
          cHamburger.classList.add('c-hamburger--dark');
        } else {
          headerBlock.classList.add('header--dark');
        }
      } else if (!isHome) {
        headerBlock.classList.remove('header--white', 'header--dark');
        headerBlock.classList.add('header--page');
        cHamburger.classList.remove('c-hamburger--dark');
      } else {
        headerBlock.classList.remove('header--dark');
      }
    }

    if (!headerBlock.querySelector('.menu').classList.contains('menu--active')) {
      if (scrollTop >= prevScrollPos && scrollTop > 0) {
        if (popoverElement) {
          popoverElement.classList.remove(activeReserveListClass);
        }
        headerBlock.classList.add(headerHideClass);
      } else {
        headerBlock.classList.remove(headerHideClass);
      }
    }

    prevScrollPos = scrollTop;
  }

  function resizeHeaderList() {
    setTimeout(() => {
      popoverElement.style.width = `${document.querySelector('.header__reserve').offsetWidth}px`;
    }, 0);
  }

  window.addEventListener('scroll', () => {
    hasScrolled();
  });

  window.addEventListener('DOMContentLoaded', () => {
    hasScrolled();
  });

  reserveButtons.addEventListener('focus', () => {
    headerBlock.classList.remove(headerHideClass);
  });

  function handleClick(e) {
    if (e.target.closest('.header__reserve')) {
      resizeHeaderList();
      popoverElement.classList.toggle(activeReserveListClass);
    } else {
      popoverElement.classList.remove(activeReserveListClass);
    }
  }

  function handleKeyup(e) {
    if ([9, 40, 38].includes(e.keyCode)) {
      if (e.target.classList.contains('header__reserve')) {
        popoverElement.classList.add(activeReserveListClass);
      } else if (!e.target.closest(`.${activeReserveListClass}`)) {
        popoverElement.classList.remove(activeReserveListClass);
      }
    }
  }

  function setupListeners() {
    resizeHeaderList();

    if (isTouchDevice() || window.innerWidth < breakpoints.md) {
      document.removeEventListener('click', handleClick);
      window.addEventListener('click', handleClick);
      document.removeEventListener('keyup', handleKeyup);

      if (reserveButtons && isTouchDevice() && window.innerWidth >= breakpoints.md) {
        reserveButtons.addEventListener('touchstart', (e) => {
          e.preventDefault();
          resizeHeaderList();
          popoverElement.classList.toggle(activeReserveListClass);
        });
      }
    } else {
      window.removeEventListener('click', handleClick);
      document.removeEventListener('keyup', handleKeyup);
      document.addEventListener('keyup', handleKeyup);
    }
  }

  if (popoverElement) {
    setupListeners();

    window.addEventListener('resize', setupListeners);
  }
}
